/**
 * Gets or sets cookies
 * @param name
 * @param value (null to delete or undefined to get)
 * @param options (domain, expire (in days))
 * @return value or true
 * http://css-tricks.com/snippets/javascript/cookie-gettersetter/
 */
let cookie = {
    get (name) {
        var n, v,
            cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            n = cookies[i].substr(0, cookies[i].indexOf('=')).trim();
            v = cookies[i].substr(cookies[i].indexOf('=') + 1);
            if (n === name){
                return window.unescape(v);
            }
        }
    },
    set (name, value, options) {
        options = options || {};
        if (!value) {
            value = '';
            options.expires = -365;
        } else {
            value = window.escape(value);
        }
        if (options.expires) {
            var d = new Date();
            d.setDate(d.getDate() + options.expires);
            value += '; expires=' + d.toUTCString();
        }
        if (options.domain) {
            value += '; domain=' + options.domain;
        }
        if (options.path) {
            value += '; path=' + options.path;
        }
        document.cookie = name + '=' + value;
    },
    remove (name, options) {
        this.set(name, null, {
            expires: -1,
            domain: window.location.hostname,
            path: '/'
        });
    }
};

export default cookie;
